export default "__VITE_ASSET__C_oz9WKf__"